import { createBrowserRouter } from "react-router-dom";
import { Navigate } from 'react-router-dom';
import NotFoundPage from "../Pages/ErrorPage/NotFoundPage";
import MainPage from "../Pages/MainPage/MainPage";
import HomePage from "../Pages/HomePage/HomePage";
import ServicesPage from "../Pages/Services/ServicesPage";
import ProfilePage from "../Pages/ProfilePage/ProfilePage";
import SettingsPage from "../Pages/Settings/SettingsPage";
import MainLayout from "../Layout/MainLayout";
import PrivacyPolicyPage from "../Pages/Settings/PrivacyPolicyPage";
import ChangePasswordPage from "../Pages/Settings/ChangePasswordPage";
import LoginPage from "../Pages/Auth/Login/LoginPage";
import ResetPasswordPage from "../Pages/Auth/ResetPassword/ResetPasswordPage";
import VerificationPage from "../Pages/Auth/ResetPassword/VerificationPage";
import ChangePasswordPage1 from "../Pages/Auth/ResetPassword/ChangePasswordPage";
import ProfileDetailPage from "../Pages/ProfileDetailPage/ProfileDetailPage";
import UserGuidePage from "../Pages/Services/UserGuidePage";
import FaqPage from "../Pages/Services/FaqPage";
import FaqDetailPage from "../Pages/Services/FaqDetailPage";
import StatisticPage from "../Pages/Statistic/StatisticPage";
import ElectricityPricePage from "../Pages/ElectricityPricePage/ElectricityPricePage";
import ElectricityPriceEditPage from "../Pages/ElectricityPricePage/ElectricityPriceEditPage";
import PlantListPage from "../Pages/PlantListPage/PlantListPage";
import AlarmPage from "../Pages/AlarmPage/AlarmPage";
import LineChatPage from "../Pages/ChartPage/LineChatPage";
import AdminLoginPage from "../Pages/Admin/Auth/login";
import DashboardAdmin from "../Pages/Admin/Dashboard/dashboard";
import LayoutAdmin from "../Pages/Admin/Layout/LayoutAdmin";
import ListAdminPage from "../Pages/Admin/ListAdmin/ListAdmin";
import ListUserPage from "../Pages/Admin/ListUser/ListUser";
import ListPLTSPage from "../Pages/Admin/ListPLTS/ListPLTS";
import ListMappingPage from "../Pages/Admin/ListMapping/listMapping";
import CreateUserAdminPage from "../Pages/Admin/ListAdmin/CreateUser";
import CreateUserEnergyPage from "../Pages/Admin/ListUser/CreateUser";
import CreatePLTSPage from "../Pages/Admin/ListPLTS/CreatePLTS";
import EditUserAdminPage from "../Pages/Admin/ListAdmin/EditUser";
import EditUserEnergyPage from "../Pages/Admin/ListUser/EditUser";
import EditPLTSPage from "../Pages/Admin/ListPLTS/EditPLTS";

let access_token_admin = localStorage.getItem("access_token_admin");


const routers = [
    {
        path: "/",
        element: <MainLayout />,
        exact: true,
        children: [
            {
                path: "/",
                element: <MainPage />,
                exact: true,
                children: [
                    {
                        path: "/:id",
                        element: <HomePage />,
                        exact: true
                    },
                    {
                        path: "/home/:id",
                        element: <HomePage />,
                        exact: true
                    },
                    {
                        path: "/",
                        element: <HomePage />,
                        exact: true
                    },
                    {
                        path: "/home/",
                        element: <HomePage />,
                        exact: true
                    },
                    {
                        path: "/services",
                        element: <ServicesPage />,
                        exact: true
                    },
                    {
                        path: "/profile",
                        element: <ProfilePage />,
                        exact: true
                    }
                ]
            },
            {
                path: "/home/statistic/",
                element: <StatisticPage />,
                exact: true
            },
            {
                path: "/home/statistic/electricityprice",
                element: <ElectricityPricePage />,
                exact: true
            },
            {
                path: "/home/statistic/electricityprice/edit",
                element: <ElectricityPriceEditPage />,
                exact: true
            },
            {
                path: "/services/userguide",
                element: <UserGuidePage />,
                exact: true
            },
            {
                path: "/services/faq",
                element: <FaqPage />,
                exact: true
            },
            {
                path: "/services/faq/detail/:id",
                element: <FaqDetailPage />,
                exact: true
            },
            {
                path: "/profile/detail",
                element: <ProfileDetailPage />,
                exact: true
            },
            {
                path: "/profile/settings",
                element: <SettingsPage />,
                exact: true
            },
            {
                path: "/profile/settings/changepassword",
                element: <ChangePasswordPage />,
                exact: true
            },
            {
                path: "/profile/settings/privacypolicy",
                element: <PrivacyPolicyPage />,
                exact: true
            },
            {
                path: "/login",
                element: <LoginPage />,
                exact: true
            },
            {
                path: "/reset-password",
                element: <ResetPasswordPage />,
                exact: true
            },
            {
                path: "/verification",
                element: <VerificationPage />,
                exact: true
            },
            {
                path: "/change-password",
                element: <ChangePasswordPage1 />,
                exact: true
            },
            {
                path: "/plant-management",
                element: <PlantListPage />,
                exact: true
            },
            {
                path: "/alarm",
                element: <AlarmPage />,
                exact: true
            },
            {
                path: "/line-chart",
                element: <LineChatPage />,
                exact: true
            },
            {
                path: "/login/success/:token",
                element: <LoginPage />,
                exact: true
            },
            {
                path: "/login/expired/:token",
                element: <LoginPage />,
                exact: true
            },
            {
                path: "/login/already/:token",
                element: <LoginPage />,
                exact: true
            }
        ]
    },
    {
        path: "/admin/login",
        element: <AdminLoginPage />,
        exact: true
    },
    {
        path: "/admin",
        element: access_token_admin ? <LayoutAdmin /> : <Navigate to="/admin/login" replace />,
        exact: true,
        children: [
            {
                path: "dashboard", 
                element: <DashboardAdmin />,
                exact: true,
            },
            {
                path: "list-admin", 
                element: <ListAdminPage />,
                exact: true,
            },
            {
                path: "list-admin/add-admin", 
                element: <CreateUserAdminPage />,
                exact: true
            },
            {
                path: "/admin/list-admin/edit-admin/:username", 
                element: <EditUserAdminPage />,
                exact: true
            },
            {
                path: "list-user", 
                element: <ListUserPage />,
                exact: true
            },
            {
                path: "list-user/add-user", 
                element: <CreateUserEnergyPage />,
                exact: true
            },
            {
                path: "/admin/list-user/edit-user/:username", 
                element: <EditUserEnergyPage />,
                exact: true
            },
            {
                path: "list-plts", 
                element: <ListPLTSPage />,
                exact: true,
            },
            {
                path: "list-plts/add-plts", 
                element: <CreatePLTSPage />,
                exact: true,
            },
            {
                path: "/admin/list-plts/edit-plts/:id", 
                element: <EditPLTSPage />,
                exact: true
            },
            {
                path: "mapping-list", 
                element: <ListMappingPage />,
                exact: true,
            }
        ]
    },
    {
        path: "*",
        element: <NotFoundPage />,
        exact: true
    }
];

const router = createBrowserRouter(routers, {basename: '/monitoring'});

export default router;